var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{attrs:{"back":"","title":"Мониторинг систем"}}),_c('get-monitoring-system')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }